module.exports = "/_next/static/images/fd50f7d28f59468c4aef3f273a7ccaf0-cards-left-large.jpg";